var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4",
    d: "M56 0H6C2.68629 0 0 2.68629 0 6V56C0 59.3137 2.68629 62 6 62H56C59.3137 62 62 59.3137 62 56V6C62 2.68629 59.3137 0 56 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon feather-message-circle",
    d: "M44 31.75C44.0052 33.7298 43.5426 35.6829 42.65 37.45C41.5916 39.5677 39.9646 41.3488 37.9512 42.594C35.9377 43.8391 33.6174 44.4991 31.25 44.5C29.2702 44.5052 27.3172 44.0426 25.55 43.15L17 46L19.85 37.45C18.9574 35.6829 18.4948 33.7298 18.5 31.75C18.5009 29.3827 19.1609 27.0623 20.4061 25.0489C21.6512 23.0354 23.4324 21.4084 25.55 20.35C27.3172 19.4574 29.2702 18.9949 31.25 19H32C35.1265 19.1725 38.0796 20.4922 40.2937 22.7063C42.5079 24.9205 43.8275 27.8735 44 31V31.75Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/ChatIcon.43e6c7b32e7fc24fcbc73fec0f9c7986.svg";
export { ForwardRef as ReactComponent };